var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-cy": "push-icon",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.947 16.522H0m5.474 1.521c.116 0 .21.098.21.218h0c0 .12-.094.217-.21.217h0a.214.214 0 0 1-.21-.217h0c0-.12.093-.218.21-.218m0 0h0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M10.947 13.043v5.218c0 .96-.754 1.739-1.684 1.739H1.684C.754 20 0 19.221 0 18.26V1.74C0 .778.754 0 1.684 0h2.527"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.105,
    height: 10.435,
    x: 5.895,
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.421 2.609h5.053M8.421 5.217h5.053M8.421 7.826h1.895"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.a8807b02.svg";
export { ForwardRef as ReactComponent };